export default __webpack_public_path__ + "static/media/notFound.bd0b844a.jpg";